/* Homepage-style expanding panels, with explicit click/touch controls and links. */
if (!customElements.get('fe-reuse-product-gallery')) {
  customElements.define('fe-reuse-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      const finePointer = matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
      this.querySelectorAll('.fe-reuse-gallery__row').forEach(row => {
        const panels = [...row.querySelectorAll('[data-reuse-panel]')];
        const buttons = panels.map(panel => panel.querySelector('.fe-reuse-panel__toggle'));
        let committed = panels[0];
        const activate = panel => {
          panels.forEach(item => {
            const expanded = item === panel;
            item.classList.toggle('is-active', expanded);
            item.querySelector('.fe-reuse-panel__toggle').setAttribute('aria-expanded', String(expanded));
            const details = item.querySelector('.fe-reuse-panel__details');
            details.inert = !expanded;
            details.setAttribute('aria-hidden', String(!expanded));
          });
        };
        panels.forEach((panel, index) => {
          const button = buttons[index];
          button.hidden = panels.length < 2;
          panel.addEventListener('fe:expand', () => {committed = panel; activate(panel);}, options);
          button.addEventListener('click', () => {committed = panel; activate(panel);}, options);
          // Expand on click, never pointer focus: resizing before release could
          // move the product link underneath a touch or a mobile-preview click.
          panel.addEventListener('pointerenter', event => {
            if (finePointer.matches && event.pointerType === 'mouse' && !row.contains(document.activeElement)) activate(panel);
          }, options);
          button.addEventListener('keydown', event => {
            const offsets = {ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1};
            let next;
            if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = buttons.length - 1;
            else if (event.key in offsets) next = (index + offsets[event.key] + buttons.length) % buttons.length;
            else return;
            event.preventDefault();
            committed = panels[next];
            activate(committed);
            buttons[next].focus();
          }, options);
          panel.addEventListener('shopify:block:select', () => {committed = panel; activate(panel);}, options);
        });
        row.addEventListener('pointerleave', () => activate(committed), options);
        activate(committed);
      });
      this.classList.add('is-ready');
    }
    disconnectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected) {
          this.events?.abort();
          this.events = null;
        }
      });
    }
  });
}
